/**
 * 휴대폰·브라우저 알림(Web Push) — 변경고시 반영, ★ 세번 변경.
 * 아이폰은 '홈 화면에 추가'로 설치한 앱(iOS 16.4+)에서만 된다. 카카오톡 안 브라우저 등은 안 된다.
 */
function token() {
  return localStorage.getItem("token") || sessionStorage.getItem("token") || "";
}

function headers(json) {
  const h = {};
  const t = token();
  if (t) h.Authorization = `Bearer ${t}`;
  if (json) h["Content-Type"] = "application/json";
  return h;
}

export function pushEnv() {
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  const isIOS = /iphone|ipad|ipod/i.test(ua) || (/mac/i.test(ua) && navigator.maxTouchPoints > 1);
  let standalone = false;
  try {
    standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  } catch { /* 무시 */ }
  const supported = typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  return { isIOS, standalone, supported, needsInstall: isIOS && !standalone };
}

function urlBase64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

async function registration() {
  const reg = await Promise.race([
    navigator.serviceWorker.ready,
    new Promise((_, reject) => setTimeout(() => reject(new Error("앱 준비가 끝나지 않았습니다. 화면을 새로 고친 뒤 다시 눌러 주세요.")), 8000)),
  ]);
  return reg;
}

/** 지금 이 기기 상태: "unsupported" | "install" | "denied" | "on" | "off" */
export async function pushState() {
  const env = pushEnv();
  if (env.needsInstall) return "install";
  if (!env.supported) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await registration();
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return "off";
    const r = await fetch(`/api/onto/push/status?endpoint=${encodeURIComponent(sub.endpoint)}`, { headers: headers() });
    if (r.ok) {
      const d = await r.json();
      if (!d.subscribed) {
        // 서버에서 지워졌다(다른 계정으로 바뀜 등) — 다시 등록
        await saveSubscription(sub);
      }
    }
    return "on";
  } catch {
    return "off";
  }
}

async function saveSubscription(sub) {
  const r = await fetch("/api/onto/push/subscribe", { method: "POST", headers: headers(true), body: JSON.stringify(sub.toJSON()) });
  if (!r.ok) {
    const d = await r.json().catch(() => ({}));
    throw new Error(d.error || `알림 등록에 실패했습니다. (${r.status})`);
  }
}

export async function enablePush() {
  const env = pushEnv();
  if (env.needsInstall) throw new Error("아이폰은 홈 화면에 설치한 앱에서만 알림을 받을 수 있습니다.");
  if (!env.supported) throw new Error("이 브라우저는 알림을 지원하지 않습니다.");
  const keyRes = await fetch("/api/onto/push/key");
  const key = keyRes.ok ? await keyRes.json() : { available: false };
  if (!key.available) throw new Error("알림 준비가 아직 끝나지 않았습니다.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("알림이 허용되지 않았습니다. 휴대폰·브라우저 설정에서 loginHS 알림을 허용해 주세요.");
  const reg = await registration();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(key.key) });
  }
  await saveSubscription(sub);
  return "on";
}

export async function disablePush() {
  const reg = await registration();
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await fetch("/api/onto/push/unsubscribe", { method: "POST", headers: headers(true), body: JSON.stringify({ endpoint: sub.endpoint }) }).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
  return "off";
}

export async function sendTestPush() {
  const r = await fetch("/api/onto/push/test", { method: "POST", headers: headers() });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `시험 알림을 보내지 못했습니다. (${r.status})`);
  return d;
}
